import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getCountdown } from '../helper/Countdown';

const BestSellsOne = () => {
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const [outdoorPlants, setOutdoorPlants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    // Fetch outdoor plants from backend
    useEffect(() => {
        const fetchOutdoorPlants = async () => {
            try {
                setLoading(true);
                const response = await fetch('http://localhost:5000/api/products?category=outdoor&limit=4');
                
                console.log('Response status:', response.status);
                
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Failed to fetch outdoor plants');
                }
                
                const data = await response.json();
                console.log('API Response:', data);
                
                if (data.success && data.data) {
                    setOutdoorPlants(data.data);
                } else {
                    setOutdoorPlants([]);
                    setError(data.message || 'No outdoor plants found');
                }
            } catch (err) {
                console.error('Error fetching outdoor plants:', err);
                setError(err.message || 'Failed to load outdoor plants');
            } finally {
                setLoading(false);
            }
        };

        fetchOutdoorPlants();
    }, []);

    // Calculate sold percentage
    const calculateSoldPercentage = (sold, stock) => {
        if (!stock || stock === 0) return 0;
        return (sold / stock) * 100;
    };

    // Format review count
    const formatReviewCount = (count) => {
        if (count >= 1000) {
            return `${(count / 1000).toFixed(1)}k`;
        }
        return count;
    };

    if (loading) {
        return (
            <section className="best sells pb-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Daily Best Sells</h5>
                        </div>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-main-600" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading outdoor plants...</p>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="best sells pb-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Daily Best Sells</h5>
                        </div>
                    </div>
                    <div className="alert alert-danger text-center" role="alert">
                        {error}
                    </div>
                </div>
            </section>
        );
    }

    if (outdoorPlants.length === 0) {
        return (
            <section className="best sells pb-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Daily Best Sells</h5>
                        </div>
                    </div>
                    <div className="alert alert-info text-center" role="alert">
                        No outdoor plants available. Please add some outdoor plants to your database.
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="best sells pb-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Daily Best Sells</h5>
                    </div>
                </div>
                <div className="row g-12">
                    <div className="col-xxl-8">
                        <div className="row gy-4">
                            {outdoorPlants.map((plant) => (
                                <div className="col-md-6" key={plant._id}>
                                    <div className="product-card style-two h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 flex-align gap-16">
                                        <div className="">
                                            <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                                                {plant.badge || `Sale ${plant.discountPercentage || 0}%`}
                                            </span>
                                            <Link
                                                to={`/product-details/${plant._id}`}
                                                className="product-card__thumb flex-center"
                                            >
                                                <img 
                                                    src={plant.image || 'https://images.unsplash.com/photo-1501004318641-b39e6451bec6?w=200&h=200&fit=crop'} 
                                                    alt={plant.name}
                                                    onError={(e) => {
                                                        e.target.src = 'https://images.unsplash.com/photo-1501004318641-b39e6451bec6?w=200&h=200&fit=crop';
                                                    }}
                                                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                            </Link>
                                            <div className="countdown" id={`countdown-${plant._id}`}>
                                                <ul className="countdown-list style-three flex-align flex-wrap">
                                                    <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium">
                                                        <span className="hours" />
                                                        {timeLeft.hours} Hours
                                                    </li>
                                                    <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium">
                                                        <span className="minutes" />
                                                        {timeLeft.minutes} Min
                                                    </li>
                                                    <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium">
                                                        <span className="seconds" />
                                                        {timeLeft.seconds} Sec
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="product-card__content">
                                            <div className="product-card__price mb-16">
                                                {plant.originalPrice && plant.originalPrice > plant.price && (
                                                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                        ₹{plant.originalPrice.toFixed(2)}
                                                    </span>
                                                )}
                                                <span className="text-heading text-md fw-semibold ">
                                                    ₹{plant.price.toFixed(2)} <span className="text-gray-500 fw-normal">/{plant.unit || 'Plant'}</span>{" "}
                                                </span>
                                            </div>
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-600">{plant.rating || 0}</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-600">({formatReviewCount(plant.reviewsCount || 0)})</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                <Link to={`/product-details/${plant._id}`} className="link text-line-2">
                                                    {plant.name}
                                                </Link>
                                            </h6>
                                            <div className="flex-align gap-4">
                                                <span className="text-main-600 text-md d-flex">
                                                    <i className="ph-fill ph-storefront" />
                                                </span>
                                                <span className="text-gray-500 text-xs">
                                                    By {plant.vendorName}
                                                </span>
                                            </div>
                                            <div className="mt-12">
                                                <div
                                                    className="progress w-100 bg-color-three rounded-pill h-4"
                                                    role="progressbar"
                                                    aria-label="Basic example"
                                                    aria-valuenow={calculateSoldPercentage(plant.sold, plant.stock)}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    <div
                                                        className="progress-bar bg-main-600 rounded-pill"
                                                        style={{ width: `${calculateSoldPercentage(plant.sold, plant.stock)}%` }}
                                                    />
                                                </div>
                                                <span className="text-gray-900 text-xs fw-medium mt-8">
                                                    Sold: {plant.sold || 0}/{plant.stock || 0}
                                                </span>
                                            </div>
                                            <Link
                                                to="/cart"
                                                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                                            >
                                                Add To Cart <i className="ph ph-shopping-cart" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-xxl-4">
                        <div className="position-relative rounded-16 bg-light-purple overflow-hidden p-28 z-1 text-center">
                            <div className="">
                                <div className="d-xxl-block d-none">
                                    <img src="assets/images/thumbs/Special-Outdoor-Plants.png" alt="" />
                                </div>
                            </div>
                            <div className="py-xl-4">
                                <h4 className="mb-8">Special Outdoor Plants</h4>
                                <div className="countdown my-32" id="countdown5">
                                    <ul className="countdown-list style-two flex-center flex-wrap">
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="hours" />
                                            {timeLeft.hours} Hours
                                        </li>
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="minutes" />
                                            {timeLeft.minutes} Min
                                        </li>
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="seconds" />
                                            {timeLeft.seconds} Sec
                                        </li>
                                    </ul>
                                </div>
                                <Link
                                    to="/shop?category=Outdoor Plants"
                                    className="mt-16 btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
                                    tabIndex={0}
                                >
                                    Shop Now
                                    <span className="icon text-xl d-flex">
                                        <i className="ph ph-arrow-right" />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BestSellsOne;